import { Component, OnDestroy, OnInit } from '@angular/core';
import { ReplaySubject, Subscription } from 'rxjs';
import { GalaxyColumnDef, GalaxyDataSource } from '@vendasta/galaxy/table';
import { ProductListPageTableRow } from './product-list-page-table-row';
import { ProductListPageDataSource } from './product-list-page-table-data-source.data-source';
import { Frequency } from '@vendasta/galaxy/frequency';
import { ProductPageService } from '../product-page.service';

@Component({
  templateUrl: './product-list-page-table-view.component.html',
  styleUrls: ['./product-list-page-table-view.component.scss'],
  standalone: false,
})
export class ProductListPageTableViewComponent implements OnInit, OnDestroy {
  protected readonly Frequency = Frequency;

  columns$$ = new ReplaySubject<GalaxyColumnDef[]>(1);
  columns$ = this.columns$$.asObservable();
  columns: GalaxyColumnDef[] = [
    {
      id: 'name',
      title: 'Name',
    },
    {
      id: 'retail-price',
      title: 'Retail price',
    },
  ];

  pageSizeOptions = [25, 50, 75, 100];
  defaultPageSize = 50;

  dataSource: ProductListPageDataSource;
  tableDataSource: GalaxyDataSource<ProductListPageTableRow>;
  subscriptions: Subscription[] = [];

  tableId = 'ssc-product-list-page-table';

  constructor(private readonly productPageService: ProductPageService) {}

  ngOnInit(): void {
    this.dataSource = new ProductListPageDataSource(this.productPageService);
    this.tableDataSource = new GalaxyDataSource<ProductListPageTableRow>(this.dataSource);
    this.columns$$.next(this.columns);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
